<template>
    <div :class="['dropZone', dragging ? 'dropZone-over' : '', validation ? '' : 'error--text']"
         @dragenter="dragging = true"
         @dragleave="dragging = false"
    >
        <div class="dropZone-info" @drag="onChange">
            <span v-if="!files.length" class="fa fa-cloud-upload dropZone-title"></span>
            <span v-if="!files.length" class="dropZone-title">Переместите или загрузите файлы</span>
            <div v-if="!files.length" class="dropZone-upload-limit-info">
                <br>
                <div>Максимальный размер файла: 5 МБ</div>
            </div>
        </div>
        <input type="file" @change="onChange" multiple>
        <div class="dropZone-uploaded-info">
            <span v-if="files.length" class="dropZone-title">Файлы загружены:</span>
            <ul>
                <li v-for="(file, index) in files" :key="index">{{ file.name }}</li>
            </ul>
            <button v-if="files.length" type="button" class="next-button button removeFile" style="margin: 0 auto;" @click="removeFiles">Удалить файлы</button>
        </div>
    </div>
</template>

<script>
    export default {
        props: ['validation', 'index'],
        data:() => ({
            files: [],
            dragging: false
        }),

        methods: {
            onChange(e) {
                let newFiles = e.target.files || e.dataTransfer.files;
                if (!newFiles.length) {
                    this.dragging = false;
                    return;
                }
                this.createFile(newFiles);
            },

            createFile(files) {
                let downloadFiles = [];
                for (let i = 0; i < files.length; i++) {
                    let file = files[i];
                    console.log(file);
                    if (file.size > 5242880) {
                        PNotify.info('Файл должен быть меньше 5 МБ.')
                        this.dragging = false;
                        return;
                    }
                    let extension = file.name.split('.')[file.name.split('.').length - 1];
                    extension = extension.toLowerCase()
                    if (extension !== 'jpg' && extension !== 'png' && extension !== 'jpeg' && extension !== 'gif' && extension !== 'pdf')  {
                        PNotify.info('Доступные расширения файлов: jpg, jpeg, gif, png, pdf');
                        this.dragging = false;
                        return;
                    }
                    downloadFiles.push(file);
                }

                this.dragging = false;

                for (let i = 0; i < downloadFiles.length; i++) {
                    const reader = new FileReader();
                    reader.readAsDataURL(downloadFiles[i]);
                    reader.onload = () => {
                        this.$emit('getFile', reader.result, this.index);
                    };
                    this.files.push(downloadFiles[i]);
                }
                downloadFiles = [];
            },
            removeFiles() {
                this.$emit('removeFiles', this.index)
            },
        },
        watch: {
            meme: {
                handler: (val) => {
                    console.log(val.length)
                },
                deep: true,
            }
        }
    }
</script>

<style scoped>
    .dropZone {
        width: 80%;
        height: 200px;
        position: relative;
        border: 2px dashed #eee;
    }

    .dropZone:hover {
        border: 2px solid #00ba57;
    }

    .dropZone:hover .dropZone-title {
        color: #00ba57;
    }

    .dropZone-info {
        color: #A8A8A8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .dropZone-title {
        color: #787878;
    }

    .dropZone input {
        position: absolute;
        cursor: pointer;
        top: 0px;
        right: 0;
        bottom: 0;
        left: 0;
        width: 100%;
        height: 100%;
        opacity: 0;
    }

    .dropZone-upload-limit-info {
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
    }

    .dropZone-over {
        background: #5C5C5C;
        opacity: 0.8;
    }

    .error--text{
        border: 2px dashed #ff5252 !important;
    }

    .error--text .dropZone-title{
        color: #ff5252 !important;
    }

    .dropZone-uploaded {
        width: 80%;
        height: 200px;
        position: relative;
        border: 2px dashed #eee;
    }

    .dropZone-uploaded-info {
        display: flex;
        flex-direction: column;
        align-items: center;
        color: #A8A8A8;
        position: absolute;
        top: 50%;
        width: 100%;
        transform: translate(0, -50%);
        text-align: center;
    }

    .removeFile {
        width: 200px;
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/FilesUpload.vue